import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  const APP_URL = "https://app.rzutnieruchomosci.pl/";

  return (
    <section className="relative pt-40 pb-20 hero-glow overflow-hidden">
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        
        <div className="text-center max-w-7xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gray-50 border border-gray-200/60 text-[13px] font-medium text-gray-600 mb-8">
              <span className="w-2 h-2 rounded-full bg-green-500"></span>
              Nowa wersja kreatora 2.0
            </div>
            <h1 className="text-5xl sm:text-7xl lg:text-[80px] text-[#1F2937] leading-[1.1] mb-6 tracking-tight">
              Projektuj rzuty nieruchomości,<br className="hidden lg:block" />
              <span className="text-gray-400">które sprzedają</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-500 font-normal mb-10 max-w-4xl mx-auto leading-relaxed">
              Przygotuj czytelne rzuty mieszkań, domów i lokali do ofert sprzedaży, wynajmu lub dokumentacji. Publikuj i wykorzystuj gotowe projekty w ciągu kilku minut.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a 
                href={APP_URL}
                className="w-full sm:w-auto bg-[#1F2937] text-white px-8 py-3.5 rounded-lg text-[15px] font-semibold hover:bg-gray-800 transition-all shadow-sm text-center"
              >
                Utwórz pierwszy rzut
              </a>
              <a 
                href="#examples" 
                className="w-full sm:w-auto bg-white text-gray-700 border border-gray-200 px-8 py-3.5 rounded-lg text-[15px] font-semibold hover:bg-gray-50 transition-all shadow-sm text-center"
              >
                Zobacz przykłady
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative mx-auto w-full max-w-[1200px]"
        >
          <div className="rounded-xl border border-gray-200/80 bg-white shadow-attio-lg overflow-hidden flex items-center justify-center">
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1784883805946-image.png" 
              alt="Interfejs Rzut Nieruchomości" 
              className="w-full h-auto object-cover" 
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}